function getIsoWeekKey(date = new Date()): string {
  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = utcDate.getUTCDay() || 7;
  utcDate.setUTCDate(utcDate.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(utcDate.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil((((utcDate.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  return `${utcDate.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
}

export function getStudioHandoffDismissalKey(userId: string): string {
  return `studio-handoff-dismissed:${userId}:${getIsoWeekKey()}`;
}

export function isStudioHandoffDismissed(userId: string): boolean {
  if (typeof localStorage === 'undefined' || !userId) {
    return false;
  }
  return localStorage.getItem(getStudioHandoffDismissalKey(userId)) === '1';
}

export function dismissStudioHandoffNotice(userId: string): void {
  if (typeof localStorage === 'undefined' || !userId) {
    return;
  }
  localStorage.setItem(getStudioHandoffDismissalKey(userId), '1');
}
